module.exports = __webpack_public_path__ + "img/public-folder-icon.d393765f.svg";